import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import TheQuestion from '../components/TheQuestion';

function TheQuestionPage() {
  return (
    <>
      <PageHero
        label="Nexus Concordat"
        title="The Question"
        subtitle="Can AI help us hold the pieces of humanity together?"
      />
      <BackButton />
      <TheQuestion />
    </>
  );
}

export default TheQuestionPage;
